<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import Navbar from '@/components/Navbar.vue'
import Notification from '@/components/Notification.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import type { ILink } from '@/misc/types'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import Api from '@/api'

const links: ILink[] = [
  {
    text: 'Home',
    url: 'home'
  },
  {
    text: 'Login',
    url: 'login'
  }
]

const authenticatedLinks: ILink[] = [
  {
    text: 'Home',
    url: 'home'
  },
  {
    text: 'Admin',
    url: 'dashboard'
  },
  {
    text: 'Logout',
    url: 'logout'
  }
]
const { isAuthenticated } = storeToRefs(useAuthStore())

onMounted(async () => {
  if (isAuthenticated.value) return
  try {
    await Api.getAuth({ silent: true })
  } catch {
    // User is not logged in or auth endpoint is unavailable.
  }
})

if (
  localStorage.getItem('color-theme') === 'dark' ||
  (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
) {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}
</script>

<template>
  <div class="min-h-screen bg-brand-neutral-50 dark:bg-brand-dark">
    <Notification />
    <Navbar :links="isAuthenticated ? authenticatedLinks : links" />
    <ImpersonationBanner />
    <div class="flex pt-10 h-screen">
      <RouterView />
    </div>
  </div>
</template>
